// extracted by mini-css-extract-plugin
module.exports = {"operationShell":"panelADS_operationShell__uwLxG","operationIconShell":"panelADS_operationIconShell__cfte_"};